import { createContext } from "react";
import type { TFlagSnapshot } from "./types";

// null = no provider above. DialogRoot renders in <App>, OUTSIDE the
// protected routes that mount FeatureFlagsProvider, so every Redux dialog
// (slides library included) lands here -- see hooks.ts for the fallback.
export const FeatureFlagsContext = createContext<TFlagSnapshot | null>(null);

// True once the flags were fetched for the current org and plan. Until then
// the snapshot is `{}` (no org yet) or the cached seed, so "off" may be wrong.
export const FeatureFlagsReadyContext = createContext(false);
